// extracted by mini-css-extract-plugin
export default {"container":"Dl-z","bubbleNav":"El-z","graphic":"Fl-z","contact":"Gl-z"};